import { useEffect, useState } from "react"
import posthog from "src/consent/posthog"
import { useAppDependencies } from "src/context/AppContext"
import StateConstants from "src/states/StateContstants"
import { formatReportPrice, planOffers } from "src/components/reports/reportPricing"
import { fireFireworks } from "src/utils/celebrate"
import { PropertyUnlockReturnStatus } from "./PropertyUnlock"
import "./SubscriptionReturnNotice.css"

const MESSAGES: Record<Exclude<PropertyUnlockReturnStatus, null>, string> = {
    unlocking: "Unlocking this home…",
    unlocked: "This home is unlocked.",
    delayed: "Payment received. Refresh in a moment to see this home.",
}

export default function PropertyUnlockReturnNotice() {
    const { stateHandler } = useAppDependencies()
    const [status, setStatus] = useState<PropertyUnlockReturnStatus>(
        stateHandler.get(StateConstants.PROPERTY_UNLOCK_RETURN_STATUS) ?? null
    )

    useEffect(() => {
        const onChange = (next: PropertyUnlockReturnStatus) => setStatus(next ?? null)
        stateHandler.addListener(StateConstants.PROPERTY_UNLOCK_RETURN_STATUS, onChange)
        return () => stateHandler.removeListener(StateConstants.PROPERTY_UNLOCK_RETURN_STATUS, onChange)
    }, [stateHandler])

    useEffect(() => {
        if (status === "unlocked") fireFireworks()
    }, [status])

    if (!status) return null

    const weekly = planOffers().find(offer => offer.plan === "week")
    const dismiss = () => stateHandler.set(StateConstants.PROPERTY_UNLOCK_RETURN_STATUS, null)
    const openPlans = () => {
        posthog?.capture("plans_opened", { source: "post_single_unlock" })
        dismiss()
        stateHandler.set(StateConstants.PLAN_MODAL_VARIANT, "choice")
        stateHandler.set(StateConstants.SHOW_PLAN_MODAL, true)
    }

    return (
        <div className={`subscription-return-notice is-${status}`} role="status" aria-live="polite">
            <span>
                {MESSAGES[status]}
                {status === "unlocked" && weekly && (
                    <> Comparing more homes? <button type="button" className="subscription-return-notice-link" onClick={openPlans}>
                        Weekly is {formatReportPrice(weekly.amount_eur)} for every home.
                    </button></>
                )}
            </span>
            {status !== "unlocking" && (
                <button type="button" className="subscription-return-notice-close" aria-label="Dismiss" onClick={dismiss}>
                    ×
                </button>
            )}
        </div>
    )
}
